<template>
<div class="chapter">
<div class="inner_page">
<p class="ct"><a href="#/contents#c2k" id="c02k">Timeline of the Torah and Judaic History</a></p>
<table border="0" style="font-size: small;" width="100%">
<colgroup>
<col width="15%"/>
<col width="2%"/>
<col width="83%"/>
</colgroup>
<tbody>
<tr><td>c. 2000–1500 B.C.E.</td>
<td>
</td><td>Abraham and the Patriarchs</td></tr>
<tr><td>c. 1500–1200 B.C.E.</td>
<td>
</td><td>Egypt, the Exodus; Moses received the Torah on Mt. Sinai</td></tr>
<tr><td>1200–1050 B.C.E.</td>
<td>
</td><td>Settlement in the Land of Israel</td></tr>
<tr><td>1050–920 B.C.E.</td>
<td>
</td><td>United kingdom under Saul, David and Solomon, with capital at Jerusalem</td></tr>
<tr><td>c. 950 B.C.E.</td>
<td>
</td><td>Solomon begins building the Temple</td></tr>
<tr><td>920–597 B.C.E.</td>
<td>
</td><td>Divided kingdom of Israel (north) and Judah (south)</td></tr>
<tr><td>722 B.C.E.</td>
<td>
</td><td>Northern Kingdom destroyed by Assyria</td></tr>
<tr><td>701 B.C.E.</td>
<td>
</td><td>Egyptians conquer Judah</td></tr>
<tr><td>605 B.C.E.</td>
<td>
</td><td>Babylon conquers Egypt, now rules Judah</td></tr>
<tr><td>586 B.C.E.</td>
<td>
</td><td>Destruction of the first temple</td></tr>
<tr><td>568–538 B.C.E.</td>
<td>
</td><td>Babylonian Exile</td></tr>
<tr><td>516 B.C.E.</td>
<td>
</td><td>Jerusalem (“Second”) Temple completed</td></tr>
<tr><td>c. 500–400 B.C.E.</td>
<td>
</td><td>The Torah, Five Books of Moses, is compiled and edited according to biblical scholarship</td></tr>
<tr><td>c. 250 B.C.E.</td>
<td>
</td><td>“Septuagint” translation of Torah into Greek</td></tr>
<tr><td>167 B.C.E.</td>
<td>
</td><td>Hasmonean (Maccabean) Revolt</td></tr>
<tr><td>70 C.E.</td>
<td>
</td><td>Rome destroys the Second Temple</td></tr>
<tr><td>c. 90–150</td>
<td>
</td><td>Canonization of Hebrew Bible essentially complete</td></tr>
<tr><td>2<sup>nd</sup> century</td>
<td>
</td><td>The ritual Passover <i>seder</i> feast was formalized</td></tr>
<tr><td>c. 200</td>
<td>
</td><td>The Oral Torah or <i>Mishnah</i> compiled and edited by Judah ha-Nasi</td></tr>
<tr><td>c. 300–600</td>
<td>
</td><td>Compilation of the Babylonian and Jerusalem Talmuds</td></tr>
<tr><td>1040–1105</td>
<td>
</td><td>Rashi, French Bible and Talmud scholar and creator of line-by-line Commentary on the Torah</td></tr>
<tr><td>1178</td>
<td>
</td><td>Maimonides completes his code of Jewish law, the <i>Mishneh Torah</i></td></tr>
<tr><td>c. 1295</td>
<td>
</td><td><i>The Zohar</i>, Kabbalistic work of mystical teaching, composed</td></tr>
<tr><td>1475</td>
<td>
</td><td>First book printed in Hebrew (Rashi’s commentary)</td></tr>
<tr><td>1492</td>
<td>
</td><td>Jews expelled from Spain</td></tr>
<tr><td>1565</td>
<td>
</td><td>Joseph Caro publishes <i>Shulchan Arukh</i>, the standard code of Jewish law and practice</td></tr>
<tr><td>1654</td>
<td>
</td><td>First Jewish settlement in North America at New Amsterdam</td></tr>
<tr><td>1700s</td>
<td>
</td><td>Founding of Hasidism</td></tr>
<tr><td>1800s</td>
<td>
</td><td>Founding of Orthodox, Reform and Conservative movements</td></tr>
<tr><td>1836</td>
<td>
</td><td>Yeshiva University founded</td></tr>
<tr><td>1897</td>
<td>
</td><td>Theodor Herzel convenes first Zionist Congress</td></tr>
<tr><td>1933–1945</td>
<td>
</td><td>The Holocaust (Shoah)</td></tr>
<tr><td>1948</td>
<td>
</td><td>State of Israel established</td></tr>
<tr><td>1950</td>
<td>
</td><td>Israeli Parliament passes the Law of Return</td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tot.vue?e5a60550